<template>
  <md-dialog
    v-model="visible"
    custom-class="overdue-reasons-force-control-close-tip-dialog"
    width="480px"
    :show-close="false"
    :close-on-click-modal="false"
    append-to-body
    @close="handleClose"
  >
    <div class="overdue-reasons-force-control-close-tip-dialog__body">
      <svg
        class="overdue-reasons-force-control-close-tip-dialog__icon"
        viewBox="0 0 64 64"
        width="64"
        height="64"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path fill="#ffd700" d="M32 4 60 56H4L32 4z" />
        <path
          fill="#1f1f1f"
          d="M32 22a3 3 0 0 0-3 3v14a3 3 0 1 0 6 0V25a3 3 0 0 0-3-3zm0 24a4 4 0 1 0 0 8 4 4 0 0 0 0-8z"
        />
      </svg>
      <div class="overdue-reasons-force-control-close-tip-dialog__title">重要提示</div>
      <div class="overdue-reasons-force-control-close-tip-dialog__message">
        <p>如涉及到的逾期订单无任何动作，</p>
        <p>
          系统将在<span class="overdue-reasons-force-control-close-tip-dialog__minutes">{{ pollMinutes }}</span
          >分钟后再次弹窗提醒，
        </p>
        <p>直至全部订单处理完成！</p>
      </div>
      <button
        type="button"
        class="overdue-reasons-force-control-close-tip-dialog__countdown"
        @click="handleCloseClick"
      >
        {{ countdown }}秒后自动关闭
      </button>
    </div>
  </md-dialog>
</template>

<script setup lang="ts">
import { computed, onUnmounted, ref, watch } from 'vue';
import { MdDialog } from 'mdesign3';

const AUTO_CLOSE_SECONDS = 5;

const props = defineProps<{
  modelValue: boolean;
  pollMinutes: number;
}>();

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void;
  (e: 'close'): void;
}>();

const visible = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit('update:modelValue', value),
});

const countdown = ref(AUTO_CLOSE_SECONDS);
let countdownTimer: ReturnType<typeof setInterval> | null = null;

const clearCountdownTimer = () => {
  if (countdownTimer) {
    clearInterval(countdownTimer);
    countdownTimer = null;
  }
};

const handleClose = () => {
  clearCountdownTimer();
  emit('close');
};

const handleCloseClick = () => {
  visible.value = false;
  handleClose();
};

const startCountdown = () => {
  clearCountdownTimer();
  countdown.value = AUTO_CLOSE_SECONDS;
  countdownTimer = setInterval(() => {
    countdown.value -= 1;
    if (countdown.value <= 0) {
      handleCloseClick();
    }
  }, 1000);
};

watch(
  () => props.modelValue,
  (isVisible) => {
    if (isVisible) {
      startCountdown();
      return;
    }
    clearCountdownTimer();
  },
);

onUnmounted(() => {
  clearCountdownTimer();
});
</script>

<style lang="less">
.overdue-reasons-force-control-close-tip-dialog {
  z-index: 200000001 !important;
  border-radius: 16px;
  overflow: hidden;
  background: #2a3038 !important;
  box-shadow: 0 12px 40px rgb(0 0 0 / 35%);

  .md-dialog__header {
    display: none;
  }

  .md-dialog__body {
    padding: 0;
    background: #2a3038;
    color: #fff;
  }

  &__body {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 36px 32px 32px;
    text-align: center;
  }

  &__icon {
    display: block;
    flex-shrink: 0;
    width: 64px;
    height: 64px;
  }

  &__title {
    margin-top: 16px;
    font-size: 20px;
    font-weight: 600;
    line-height: 28px;
    color: #f0c78a;
  }

  &__message {
    margin-top: 20px;
    font-size: 15px;
    line-height: 28px;
    color: #fff;

    p {
      margin: 0;
    }
  }

  &__minutes {
    margin: 0 2px;
    font-weight: 600;
  }

  &__countdown {
    margin-top: 32px;
    min-width: 180px;
    height: 44px;
    padding: 0 28px;
    border: none;
    border-radius: 999px;
    background: rgb(255 255 255 / 12%);
    font-size: 15px;
    font-weight: 500;
    line-height: 44px;
    color: #f0c78a;
    cursor: pointer;
    outline: none;
    transition: background-color 0.2s;

    &:hover {
      background: rgb(255 255 255 / 18%);
    }
  }
}
</style>
